// @ts-ignore
const { SERVER_API_URL, GCP_THUMB_BUCKET_NAME } = MULTIPOLAR_ENV

export const jsonVersions = ['1.0.0', '1.1.0']
export const currentJsonVersion = jsonVersions[jsonVersions.length - 1]

export const API_GET_DOWNLOAD_URL = `${SERVER_API_URL}/get-download-url`
export const API_GET_UPLOAD_URL = `${SERVER_API_URL}/get-upload-url`
export const API_GET_THUMB_UPLOAD_URL = `${SERVER_API_URL}/get-thumb-upload-url`
export const API_GET_GALLERY_LIST_URL = `${SERVER_API_URL}/get-listing`
export const THUMBNAIL_URL_BASE = `https://storage.googleapis.com/${GCP_THUMB_BUCKET_NAME}`

export const THUMBNAIL_SIZE = 150

export const CHANNEL_PATH = 'channels/kirlen'
export const DEFAULT_CHANNEL_ID = 'default'
